import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesCoupons } from "../../constants";
import { CouponItem } from "../../coupons.types";

export const requestCoupons = async (
  params: GetListRequestParams
): Promise<GetListResponse<CouponItem>> => {
  return await instance.get(ApiRoutesCoupons.Coupons, { params });
};
